// Add your custom JS here.
// Add your JS customizations here
jQuery(function() {
	var prev = 0;
	var jQuerywindow = jQuery(window);
	var nav = jQuery('.scrollhide-nav');

	jQuerywindow.on('scroll', function(){
	var scrollTop = jQuerywindow.scrollTop();
	if (scrollTop > 0) {
		nav.toggleClass('hidden', scrollTop > prev);
		prev = scrollTop;
	} else {
		if (nav.hasClass('hidden')) {
		nav.removeClass('hidden');
		}
	}
	});

	if (jQuery('.match').length) {
		jQuery('.match').matchHeight();
	}
	if (jQuery('.match2').length) {
		jQuery('.match2').matchHeight();
	}

	// var slider = jQuery('#header-slideshow');
	// if (slider.length) {
	// 	tns({
	// 		container: '#header-slideshow',
	// 		mode: 'gallery',
	// 		autoplay: true,
	// 		controls: false,
	// 		nav: false,
	// 		speed: 1000,
	// 		autoplayButton: false
	// 	});
	// }
	jQuery('section[class*="tausta-"]').each(function() {
		if ( jQuery(this).nextAll('section').first().is('[class*="tausta-"]') ) {
			jQuery(this).next('.tausta_b').css('marginBottom', '-6rem');
			jQuery(this).nextAll('section').first().css('paddingTop', '4rem');
			jQuery(this).nextAll('section').first().prev('.tausta_a').hide();
		}
	});
});

jQuery('.accordion .card-header button').on('click', function() {
	jQuery(this).parents('.accordion').find('i').removeClass('fa-minus').addClass('fa-plus');
	if (jQuery(this).hasClass('collapsed')) {
		jQuery(this).find('i').toggleClass('fa-plus fa-minus')
	}
});

const swiper = new Swiper('.swiper', {
	navigation: {
		prevEl: '.swiperjs-button-prev',
		nextEl: '.swiperjs-button-next'
	},
	autoplay: {
		delay: 5000,
	},
	loop: true,
	slidesPerView: 'auto',
});

jQuery.fn.animateNumbers = function(stop, commas, duration, ease) {
	return this.each(function() {
		var $this = jQuery(this);
		var start = parseInt($this.text().replace(/,/g, ""));
		commas = (commas === undefined) ? true : commas;
		jQuery({value: start}).animate({value: stop}, {
			duration: duration === undefined ? 1000 : duration,
			easing: ease === undefined ? "swing" : ease,
			step: function() {
				$this.text(Math.floor(this.value));
				if (commas) { $this.text($this.text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")); }
			},
			complete: function() {
				if (parseInt($this.text()) !== stop) {
					$this.text(stop);
					if (commas) { $this.text($this.text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")); }
				}
			}
		});
	});
};

var animated = false;

jQuery(function() {
	jQuery('.numbers-list-wrapper .number-value').each(function(){
		let original = jQuery(this).text();
		jQuery(this).data('number', original).html('0');
	});

	hoyryAnimate();

	jQuery(window).on('scroll', hoyryAnimate);
});

function hoyryAnimate() {
	var mittaristo = jQuery('.numbers-list-wrapper');

	if (!mittaristo.length) return;

	mittaristo = mittaristo.offset().top - (jQuery(window).height() * 0.9);

	var b = jQuery(window).scrollTop();

	if (parseInt(b, 10) > mittaristo && !animated) {
		animated = true;
		jQuery('.numbers-list-wrapper .number-value').each(function(){
			// Animate the element's value from x to y:
			var number = jQuery(this).data('number');
			var content = jQuery(this).text();
			if (content.indexOf("0") >= 0){
				jQuery(this).animateNumbers( number, false, 2000, "linear" );
			}
		});
	}
}
